import banner from "../../../courses/module-2/img6.png";

const modulo6 = {
  courseId: "cripto-blockchain",
  id: "modulo-6",
  title: "🧩 MODULE 6: DeFi, NFTs and Other Weird Words",
  estimatedDuration: "1 hour 30 minutes",
  format: "Reading + practical activity",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objective",
      content: [
        "Understand the most common and confusing concepts you will find when exploring the Web3 world: what DeFi is, what NFTs are used for, and what terms like DAO, staking, or farming mean.",
      ],
    },
    {
      id: "que-es-defi",
      navLabel: "What is DeFi?",
      title: "💬 What is DeFi (Decentralized Finance)?",
      content: [
        {
          type: "paragraph",
          text: 'DeFi means "Decentralized Finance" and refers to an entire ecosystem of financial applications built on blockchain that do not depend on banks, governments, or traditional intermediaries.',
        },
        {
          type: "paragraph",
          text: "Instead of using a bank to request a loan, earn interest, or exchange currencies, you do it directly with other users through smart contracts.",
        },
        {
          type: "paragraph",
          text: "📌 Real examples:",
        },
        {
          type: "list",
          items: [
            "Aave: a platform where you can borrow crypto or lend your funds to earn interest.",
            "Uniswap: lets you exchange tokens without needing a traditional exchange.",
            "Compound: lets you earn interest by depositing your cryptocurrencies.",
          ],
        },
        {
          type: "paragraph",
          text: "🧾 Key term: Smart contract",
        },
        {
          type: "paragraph",
          text: "Smart contracts are programs that run automatically when certain conditions are met. For example: “if Marcos deposits USDC, send him 3% annual interest.”",
        },
      ],
    },
    {
      id: "que-son-nfts",
      navLabel: "What are NFTs?",
      title: "🎨 What are NFTs?",
      content: [
        {
          type: "paragraph",
          text: "NFT means Non-Fungible Token. Unlike a cryptocurrency like BTC, which you can exchange for another identical unit, an NFT is unique, like a digital artwork.",
        },
        {
          type: "paragraph",
          text: "🎯 Characteristics:",
        },
        {
          type: "list",
          items: [
            "They are digital certificates of ownership.",
            "They live on the blockchain.",
            "They can represent art, music, tickets, video games, digital identities, and even physical objects.",
          ],
        },
        {
          type: "paragraph",
          text: "📌 Real examples:",
        },
        {
          type: "list",
          items: [
            "NBA Top Shot: official collectible videos of basketball plays.",
            "Bored Ape Yacht Club: a collection of digital artworks that became digital status symbols.",
            "Axie Infinity: a game where each creature you use is an NFT.",
          ],
        },
      ],
    },
    {
      id: "otros-conceptos",
      navLabel: "Other concepts",
      title: "🛠 Other key concepts",
      content: [
        {
          type: "table",
          headers: ["Term", "What does it mean?", "Real example"],
          rows: [
            [
              "Staking",
              "Leaving your crypto “locked” to validate the network and receive rewards.",
              "Staking ADA on Cardano and earning 5% annually",
            ],
            [
              "DAO",
              "An autonomous organization governed by its members with blockchain rules.",
              "An artist collective that decides which works to fund",
            ],
            [
              "Airdrop",
              "A free token reward for participating in a project or using an app.",
              "You used a dApp and received new tokens for free",
            ],
            [
              "Yield farming",
              "Moving your funds between several DeFi platforms to maximize returns.",
              "Depositing USDC in one app, withdrawing it, and moving it to another with higher yield",
            ],
          ],
        },
      ],
    },
    {
      id: "tabla-resumen",
      navLabel: "Summary",
      title: "🧩 Summary table – Key Web3 concepts",
      content: [
        {
          type: "table",
          headers: ["Term", "Simple definition", "Real example or comparison"],
          rows: [
            [
              "DeFi",
              "Finance without banks",
              "Using Uniswap instead of a traditional exchange",
            ],
            [
              "NFT",
              "A unique digital file",
              "A digital painting that only you own",
            ],
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Resources",
      title: "📌 Recommended resources",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/the-complete-beginners-guide-to-decentralized-finance-defi",
          text: "Binance Academy – DeFi explained",
        },
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-is-an-nft",
          text: "Binance Academy – What is an NFT",
        },
        {
          type: "link",
          href: "https://www.coinbase.com/learn/nfts-daos-and-more",
          text: "Coinbase Learn – NFTs, DAOs and more",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "🎯 Module activity",
      content: [
        {
          type: "paragraph",
          text: "🧪 Practical challenge – “Exploring the Web3 ecosystem”",
        },
        {
          type: "paragraph",
          text: "1. Search online for a real NFT or DeFi project. It can be in Spanish or English.",
        },
        {
          type: "paragraph",
          text: "2. Research:",
        },
        {
          type: "list",
          items: [
            "What problem does it solve?",
            "What network does it use, such as Ethereum, Polygon, etc.?",
            "What utility does it offer users?",
          ],
        },
        {
          type: "paragraph",
          text: "3. Create a Google Docs document with a short description, around 5–8 lines.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Quote of the day",
      title: "🧠 Quote of the day",
      content: [
        "“The future belongs to those who understand technology… but also to those who know how to use it with purpose.”",
      ],
    },
  ],
};

export default modulo6;
